<div
  class="flex flex-column row-gap-3"
  [class.loading-box]="fetchingCalendars"
>
  <div style="width: fit-content;" [ngbTooltip]="disabled ? (disabledTooltip | translate) : ('admin.google-calendar-sync.connect-btn.tooltip' | translate)">
    <label (click)="onConnect()" [class.p-disabled]="disabled" class="flex flex-row align-items-center justify-content-between py-2 px-3 column-gap-3 border-solid border-1 border-round cursor-pointer" style="border-color: #CED4DA; width: fit-content;">
      <app-google-calendar-icon class="flex" />
      <span class="font-bold text-blue-500">{{ 'admin.google-calendar-sync.connect-btn.label' | translate }}</span>
    </label>
  </div>
  @if (calendars.length) {
    <div class="flex flex-column column-gap-1">
      <span>{{ 'admin.google-calendar-sync.connect-calendars.label' | translate }}</span>
      @for (calendar of calendars; track calendar) {
        <span
          class="flex flex-row align-items-center justify-content-between py-2 px-3 column-gap-3 border-solid border-1"
          [class.border-top-none]="!$first"
          [class.border-round-top]="$first"
          [class.border-round-bottom]="$last"
          [class.loading-box]="calendar.id ? deletingCalendarMap[calendar.id] : false"
          style="border-color: #CED4DA;">
          <div class="flex flex-row column-gap-2 align-items-center">
            <app-google-calendar-icon class="flex" />
            <div class="flex flex-column">
              <span class="font-bold">{{ calendar.title }}</span>
              <div class="flex align-items-center details-block-wrap">
                <span class="detail-block">{{ calendar.ownerEmail }}</span>
                <span class="detail-block calendar-id">{{ calendar.externalId }}</span>
              </div>
            </div>
          </div>
          <button
            pButton
            [ngbTooltip]="'admin.google-calendar-sync.disconnect-calendar.tooltip' | translate"
            (click)="onRemove(calendar)"
            icon="pi pi-times"
            class="p-button-text p-button-plain p-button-rounded">
          </button>
        </span>
      }
    </div>
  }
</div>
